export default class PoItemShipUnit {
  shipUnitId: string;
  loadMethod: string;
  priorLoadMethod: string;
  pallet: number;
  palletSpaces: number;
  volume: number;
  weight: number;
  cartons: number;
  nmfcClass: string;
  volumeBkp: number;
  volumeWithCommas: boolean;
  weightWithCommans: boolean;
  oversized: boolean;
  existingUnit: boolean;

  constructor(
    shipUnitId: string,
    loadMethod: string,
    priorLoadMethod: string,
    pallet: number,
    palletSpaces: number,
    volume: number,
    weight: number,
    cartons: number,
    nmfcClass: string,
    volumeBkp: number,
    volumeWithCommas: boolean,
    weightWithCommans: boolean,
    oversized: boolean,
    existingUnit: boolean
  ) {
    this.shipUnitId = shipUnitId;
    this.loadMethod = loadMethod;
    this.priorLoadMethod = priorLoadMethod;
    this.pallet = pallet;
    this.palletSpaces = palletSpaces;
    this.volume = volume;
    this.weight = weight;
    this.cartons = cartons;
    this.nmfcClass = nmfcClass;
    this.volumeBkp = volumeBkp;
    this.volumeWithCommas = volumeWithCommas;
    this.weightWithCommans = weightWithCommans;
    this.oversized = oversized;
    this.existingUnit = existingUnit;
  }
}
